import { render, staticRenderFns } from "./PaymentMethodsStep.vue?vue&type=template&id=012d2b09&"
import script from "./PaymentMethodsStep.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsStep.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsStep.vue?vue&type=style&index=0&id=012d2b09&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports